import type { Logger } from 'tokyu-hooks'

function getRollbar(): unknown {
  // window.Rollbar is injected by the Rollbar snippet — no type package available
  return typeof window !== 'undefined' ? (window as any)?.Rollbar : undefined
}

export const clientLogger: Logger = {
  debug: (message, context) => console.debug(message, context),
  info: (message, context) => {
    console.info(message, context)
    ;(getRollbar() as any)?.info(message, context)
  },
  warn: (message, context) => {
    console.warn(message, context)
    ;(getRollbar() as any)?.warning(message, context)
  },
  error: (message, error, context) => {
    console.error(message, error, context)
    ;(getRollbar() as any)?.error(message, error, context)
  },
}
